/**
 * recharge-widget.js
 * Custom JS for Recharge subscription widget on PDPs.
 * Added by Daniel on April 2 2026.
 *
 * Recharge renders its subscription widget inside a shadow DOM,
 * so standard CSS and JS cannot target its elements directly.
 * This file uses shadowRoot access to access and modify the widget.
 *
 * Customizations:
 *  1. Hides the redundant Shopify-rendered price outside the One-time option
 *  2. Injects the Shopify compare-at price (strikethrough) into the One-time
 *     option block, styled to match Recharge's native strikethrough price style
 *  3. Hides the duplicate strikethrough price in the sticky cart bar
 */


// Inject PDP-scoped CSS to hide the redundant Shopify theme price block
(function injectStyles() {
  // Always inject immediately — no race condition for the sticky bar rule
  const style = document.createElement('style');
  style.textContent = `
    .cart-bar .product__price--strike {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  // Poll for Recharge before hiding the main price block
  function hideMainPrice() {
    if (document.querySelector('recharge-subscription-widget')) {
      const s = document.createElement('style');
      s.textContent = `.price.product__price { display: none !important; }`;
      document.head.appendChild(s);
    } else {
      setTimeout(hideMainPrice, 200);
    }
  }
  hideMainPrice();
})();
 
function patchRechargeWidget() {
  const widget = document.querySelector('recharge-subscription-widget');
  if (!widget || !widget.shadowRoot) return false;
 
  const shadow = widget.shadowRoot;

  // Inject CSS to hide prepaid plan title on Gift Subscription products
  if (!shadow.querySelector('#eq-prepaid-hide')) {
    const productId = document.querySelector('[data-product-id]')?.dataset?.productId;
    const hideIds = ['7413360394322', '7413360492626', '7413360459858'];
    if (hideIds.includes(productId)) {
      const style = document.createElement('style');
      style.id = 'eq-prepaid-hide';
      style.textContent = `[part="rc-prepaid-plan__title"] { display: none !important; }`;
      shadow.appendChild(style);
    }
  }

  const pricesDiv = shadow.querySelector('.rc-selection__onetime .rc-purchase-option__prices');
  const comparePrice = document.querySelector('s.price-item--regular');
 
  // Don't run again if already patched
  if (pricesDiv && pricesDiv.querySelector('.eq-compare')) return true;
 
  if (pricesDiv && comparePrice) {
    const span = document.createElement('span');
    span.className = 'rc-price strike-through text-muted eq-compare';
    span.textContent = comparePrice.textContent.trim();
    pricesDiv.prepend(span);
    return true;
  }
 
  return false;
}
 
// Watch for Recharge to render into the DOM, then patch it
const observer = new MutationObserver(function () {
  if (patchRechargeWidget()) observer.disconnect();
});
 
observer.observe(document.body, { childList: true, subtree: true });
 
// Also try immediately in case widget is already rendered
patchRechargeWidget();
 
// Update compare-at price when variant changes
function updateComparePrice() {
  const widget = document.querySelector('recharge-subscription-widget');
  if (!widget || !widget.shadowRoot) return;
  const shadow = widget.shadowRoot;

  const pricesDiv = shadow.querySelector('.rc-selection__onetime .rc-purchase-option__prices');
  if (!pricesDiv) return;
 
  const comparePrice = document.querySelector('s.price-item--regular');
  let injected = shadow.querySelector('.eq-compare');
 
  if (comparePrice) {
    if (!injected) {
      // Span doesn't exist yet, create it
      injected = document.createElement('span');
      injected.className = 'rc-price strike-through text-muted eq-compare';
      pricesDiv.prepend(injected);
    }
    injected.textContent = comparePrice.textContent.trim();
    injected.style.display = '';
  } else if (injected) {
    injected.style.display = 'none';
  }
}
 
document.addEventListener('change', function (e) {
  if (!e.target.matches('[name^="Size"], [name^="Grind"], .product-variant-id, [data-option-value-id]')) return;
  updateComparePrice();
  setTimeout(updateComparePrice, 100);
  setTimeout(updateComparePrice, 300);
});